import { Component, OnInit, Input, ViewEncapsulation, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { ISearchWell } from '../../../models/well/searchWell';
import { VoucherService } from '../../../services/voucher-service';
import { VoucherApplication } from '../../../models/vouchers/voucher-application';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from 'app/services/core/shared.service';
import { IHousehold } from 'app/models/household/household';
import { ISearchResult } from 'app/models/well/search/search.result';
import { HouseholdSearch } from 'app/models/household/household-search';
import { HouseholdService } from 'app/services/household-service';
import { HousingUnitService } from 'app/services/housingunit-service';
import { IVoucherSearchResult } from 'app/models/vouchers/voucher.search.result';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DialogEditVoucherComponent } from './voucher-edit-dialog';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@shared/auth/auth.service';
import { IFuzzySearchResult } from 'app/models/common/fuzzySearchResult';

@Component({
  selector: 'application-edit',
  templateUrl: 'application-edit.component.html',
  styleUrls: ['../add/add-voucher-application.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditVoucherApplicationComponent implements OnInit {
  @Input('applicationId')
  applicationId: number = 0;
  applicationTypes: string[] = this.voucherService.voucherTypes;
  canEdit = false;
  applicationStatuses: string[] = this.voucherService.statuses;
  formHouseholdSize: number = 0;
  loading: boolean = true;
  primaryRaceEthnicity: Array<{ id: string, value: string }> = [];
  processing: boolean = false;
  buttonText = "";
  showWildfireCard = false;
  showLubgwmaCard = false;
  lubgwmaValidationError: boolean = false;
  showWell: boolean = false;
  showWellResults: boolean = false;
  showVoucherResults: boolean = false;
  showWellResultsDiv: boolean = false;
  tooltipMessage1: string = "To add a comment, select the Other option and then click in the area below it (Other comments)."
  tooltipMessage2: string = "To enter a SPACE between words, hold down the SHIFT button while you hit the SPACE BAR."
  wellAssociated: boolean = false;
  housingUnitAssociated: boolean = false;
  householdAssociated: boolean = false;
  isIssued: boolean = false;
  showSelfGeneratedVoucherIdentifer: boolean = false;
  wells: IFuzzySearchResult[] = [];
  housingUnits: IHousehold[] = [];
  households: IHousehold[] = [];

  showHousehold: boolean = false;
  householdSelected: number = 0;

  showHousingUnit: boolean = false;
  housingUnitSelected: number = 0;

  displayedColumns: string[] = ['wellId', 'wellAddress1', 'wellCity', 'wellZip', 'wellCounty', 'wellLog', 'wellTag', 'housingUnits'];
  dataSource = new MatTableDataSource<IFuzzySearchResult>(this.wells);

  dataSourceHousehold = new MatTableDataSource<IHousehold>([]);
  displayedColumnsHousehold: string[] = ['householdId', 'contactName', 'address', 'city', 'zip', 'county', 'score'];

  dataSourceHousingUnit = new MatTableDataSource<IHousehold>([]);
  displayedColumnsHousingUnit: string[] = ['housingUnitId', 'contactName', 'address', 'city', 'zip', 'county', 'score'];

  displayedColumnsVouchers: string[] = ['id', 'applicationId', 'applicationStatus', 'applicationType', 'wellAddress', 'wellCity', 'wellState', 'wellZip', 'wellCounty', 'wellLog', 'wellLabelTagNumber'];
  dataSourceVouchers = new MatTableDataSource<IHousehold>();
  flatVoucherResults: IHousehold[] = [];
  flatHouseholdResults: IHousehold[] = [];
  flatHousingUnitResults: IHousehold[] = [];

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  searchWell: ISearchWell = {
    address: '',
    county: '',
    city: '',
    state: '',
    zip: '',
    searchBy: 'Well',
    searchResultsMaxRows: '10',
    wellId: ''
  }

  householdSearch: HouseholdSearch = {
    id: '',
    contactName: '',
    address1: '',
    city: '',
    zip: '',
    searchText: '',
    county: '',
    pregnancyInHousehold: false,
    infantsUnder1: false,
    age1to4: false,
    age5to9: false,
    age10to14: false,
    age15to19: false,
    age20to29: false,
    age30to39: false,
    age40to49: false,
    age50to59: false,
    age60to69: false,
    age70to79: false,
    age80Plus: false,
    waterTreamentProvided: false,
    bottledWaterProvided: false,
    age15AndBelow: false,
    age16AndAbove: false,
    infantsInHousehold: false,
    searchBy: 'Household',
    searchResultsMaxRows: ''
  };

  housingUnitSearch: HouseholdSearch = {
    id: '',
    contactName: '',
    address1: '',
    city: '',
    zip: '',
    searchText: '',
    county: '',
    pregnancyInHousehold: false,
    infantsUnder1: false,
    age1to4: false,
    age5to9: false,
    age10to14: false,
    age15to19: false,
    age20to29: false,
    age30to39: false,
    age40to49: false,
    age50to59: false,
    age60to69: false,
    age70to79: false,
    age80Plus: false,
    waterTreamentProvided: false,
    bottledWaterProvided: false,
    age15AndBelow: false,
    age16AndAbove: false,
    infantsInHousehold: false,
    searchBy: 'Household',
    searchResultsMaxRows: ''
  };

  application: VoucherApplication = {
    // Application
    id: 0,
    createDate: '',
    createdby: '',
    modifyDate: '',
    modifiedBy: '',
    applicationStatus: this.voucherService.new,
    applicationType: '',
    newApplication: true,
    respondentID: 0,
    collectorID: 0,
    startDate: new Date().toLocaleString(),
    endDate: '',
    customData1: '',
    preferredContactType: '',
    preferredContactComments: '',
    allInfoCorrect: true,
    reviewDate: '',
    reviewedBy: '',
    statusComments: '',

    // Well
    privateWellHoushold: '',
    privateWellProperty: '',
    createNewWell: false,

    selectedWellId: 0,
    associatedWellAddress: '',
    associatedWellCity: '',
    associatedWellState: '',
    associatedWellZip: '',
    associatedWellCounty: '',

    wellDamage: '',
    wellDamageComments: '',
    wellSystemPlasticRubber: '',
    wellAddressName: '',
    wellAddressCompany: '',
    wellAddress: '',
    wellCity: '',
    wellState: '',
    wellZip: '',
    wellCounty: '',
    wellLabelTagNumber: '',
    wellLogNumber: '',

    // Wildfire
    propertyImpacted: '',
    previousVoucher: '',
    wildfire: [],
    wildfireOther: '',

    // Applicant
    applicantContactName: '',
    applicantAddress: '',
    applicantCity: '',
    applicantState: '',
    applicantZip: '',
    applicantContactEmail: '',
    applicantContactPhone: '',

    // Household
    primaryResidence: '',
    residenceOther: '',
    householdsServed: '',
    householdsServedOther: '',
    tenant: '',
    householdShared: '',
    householdSize: '',
    householdSizeOther: '',
    household1PersonIncome: '',

    confidential: '',
    householdPrivateWell: '',
    propertyLocation: '',
    wellNitrateTest: '',
    wellNitrateTestOther: '',

    //  Real-d
    volunteerRaceEthInfo: '',
    centralAmerican: false,
    mexican: false,
    southAmerican: false,
    otherLatinx: false,
    chamoru: false,
    marshallese: false,
    micronesian: false,
    nativeHawaiian: false,
    samoan: false,
    otherPacificIslander: false,
    slavic: false,
    westernEuropean: false,
    easternEuropean: false,
    otherWhite: false,
    americanIndian: false,
    alaskaNative: false,
    canadianFirstNation: false,
    indigenousCentralAmerican: false,
    africanAmerican: false,
    afroCarribbean: false,
    filipino: false,
    somali: false,
    ethiopian: false,
    otherAfrican: false,
    otherBlack: false,
    middleEastern: false,
    northAfrican: false,
    asianIndian: false,
    cambodian: false,
    chinese: false,
    myanmar: false,
    hmong: false,
    japanese: false,
    korean: false,
    laotian: false,
    southAsian: false,
    vietnamese: false,
    otherAsian: false,
    dontKnow: '',
    raceEthOther: '',
    raceEthDecline: false,
    raceEthPrimary: '',
    raceEthPrimaryOther: '',
    languagAtHome: '',
    languageAtHomeOther: '',
    languageSpoken: '',
    languageWritten: '',
    needInterpreter: '',
    needInterpreterType: '',
    needInterpreterTypeOther: '',
    englishProficiency: '',
    hearing: '',
    hearingComments: '',
    vision: '',
    visionComments: '',
    mobility: '',
    mobilityComments: '',
    focus: '',
    focusComment: '',
    dressingBathing: '',
    dressingBathingComments: '',
    learning: '',
    learningComments: '',
    learnAboutVoucher: '',
    learnAboutVoucherOther: '',
    whoIsCompletingForm: '',
    communityBasedOrganizationEmail: '',
    communication: '',
    communicationComments: '',
    selfSupport: '',
    selfSupportComments: '',
    moods: '',
    moodsComments: '',
    voucherResponseRowKey: '',
    selfGenerateVoucherIdentifier: false,
    selfGeneratedVoucherIdentifer: '',
    wellLat: '',
    wellLong: '',
    age15AndBelow: 0,
    age16AndAbove: 0,
    pregnancyInHousehold: false,
    infantsInHousehold: false,
    canvasCode: '',
    applicantAddressUnit: '',
    createNewHousehold: false,
    selectedHouseholdId: 0,
    createNewHousingUnit: false,
    selectedHousingUnitId: 0,
    ohaWellId: '',
    ohaHousingUnitId: '',
    ohaHouseholdId: '',
    householdLatitude: '',
    householdLongitude: '',
    scheduleTest: false,
    preferredSampleDays: '',
    preferredSampleTimes: '',
    applicationSource: '',
    applicantCounty: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    mailingCounty: '',
    residenceType: '',
    residenceTypeOther: ''
  }

  voucherApplicationForm: FormGroup = null;

  constructor(public oregonWellDataService: OregonWellDataService, public voucherService: VoucherService,
    private toastr: ToastrService, private route: ActivatedRoute, private router: Router, private sharedService: SharedService,
    public householdService: HouseholdService, public authService: AuthService,
    public housingUnitService: HousingUnitService, public dialog: MatDialog,) {

    this.applicationId = Number(this.route.snapshot.paramMap.get("id"));
    if (this.applicationId == 0) {
      this.applicationTypes = this.voucherService.voucherTypesForNewApplications
    }
  }

  ngOnInit(): void {
    this.loadApplication();
  }

  pullApplicantAddress() {
    this.sharedService.openConfirm("Are you sure you want override the well address with the applicant address?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.voucherApplicationForm.get('wellAddress').setValue(this.voucherApplicationForm.value.applicantAddress);
        this.voucherApplicationForm.get('wellCity').setValue(this.voucherApplicationForm.value.applicantCity);
        this.voucherApplicationForm.get('wellState').setValue(this.voucherApplicationForm.value.applicantState);
        this.voucherApplicationForm.get('wellZip').setValue(this.voucherApplicationForm.value.applicantZip);

      }
    });
  }

  typeChange() {
    this.showWildfireCard = this.voucherApplicationForm.value.applicationType == this.voucherService.wildfireVoucherType;

    this.showLubgwmaCard = this.voucherApplicationForm.value.applicationType == this.voucherService.lubgwmaTestingVoucherType
      || this.voucherApplicationForm.value.applicationType == this.voucherService.lubgwmaTreatmentVoucherType;
  }

  loadApplication() {
    this.canEdit = false;
    this.showWildfireCard = false;
    this.showLubgwmaCard = false;
    this.isIssued = false;

    if (this.applicationId > 0) {
      this.buttonText = "Update Application & Real-D";
      this.voucherService.getVoucherApplicationById(this.applicationId).subscribe(
        result => {
          this.application = result;

          if (this.application.applicationType == this.voucherService.wildfireVoucherType) {
            this.showWildfireCard = true;
          }

          if (this.application.applicationType == this.voucherService.lubgwmaTestingVoucherType
            || this.application.applicationType == this.voucherService.lubgwmaTreatmentVoucherType) {
            this.showLubgwmaCard = true;
          }

          if (this.application.applicationStatus != this.voucherService.issued) {
            this.canEdit = true;
          }
          else {
            this.isIssued = true;
          }

          if (this.application.selfGeneratedVoucherIdentifer != null && this.application.selfGeneratedVoucherIdentifer.length > 0) {
            this.application.selfGenerateVoucherIdentifier = true;
          }


          this.setFormValues();
          this.loading = false;
        },
        error => {
          this.toastr.error(error.message);
          this.loading = false;
        }
      );
    }
    else {
      this.buttonText = "Add Application & Real-D";
      this.loading = false;
      this.canEdit = true;
      this.setFormValues();

      // removed issued as an option from the application statuses
      this.applicationStatuses = this.applicationStatuses.filter(s => s != this.voucherService.issued);
    }
  }

  setFormValues() {
    this.voucherApplicationForm = new FormGroup({
      applicationStatus: new FormControl({ value: this.voucherService.new, disabled: this.isIssued ? true : false }, Validators.required),
      applicationType: new FormControl({ value: '', disabled: this.applicationId > 0 ? true : false }, Validators.required),

      preferredContactType: new FormControl({ value: '', disabled: !this.canEdit }),
      selectedWellId: new FormControl({ value: 0, disabled: !this.canEdit }),

      wellLookup: new FormControl({ value: '', disabled: !this.canEdit }),
      preferredContactComments: new FormControl({ value: '', disabled: !this.canEdit }),
      applicantContactName: new FormControl({ value: '', disabled: !this.canEdit }, Validators.required),
      applicantContactEmail: new FormControl({ value: '', disabled: !this.canEdit }),
      applicantContactPhone: new FormControl({ value: '', disabled: !this.canEdit }, Validators.required),
      applicantAddress: new FormControl({ value: '', disabled: !this.canEdit }, Validators.required),
      applicantCity: new FormControl({ value: '', disabled: !this.canEdit }, Validators.required),
      applicantState: new FormControl({ value: '', disabled: !this.canEdit }, Validators.required),
      applicantZip: new FormControl({ value: '', disabled: !this.canEdit }, Validators.required),
      applicantCounty: new FormControl({ value: '', disabled: !this.canEdit }),

      mailingAddress: new FormControl({ value: '', disabled: !this.canEdit }),
      mailingCity: new FormControl({ value: '', disabled: !this.canEdit }),
      mailingState: new FormControl({ value: '', disabled: !this.canEdit }),
      mailingZip: new FormControl({ value: '', disabled: !this.canEdit }),
      mailingCounty: new FormControl({ value: '', disabled: !this.canEdit }),

      // well
      wellAddress: new FormControl({ value: '', disabled: !this.canEdit }),
      wellCity: new FormControl({ value: '', disabled: !this.canEdit }),
      wellState: new FormControl({ value: '', disabled: !this.canEdit }),
      wellZip: new FormControl({ value: '', disabled: !this.canEdit }),
      wellCounty: new FormControl({ value: '', disabled: !this.canEdit }),
      wellLabelTagNumber: new FormControl({ value: '', disabled: !this.canEdit }),
      wellLogNumber: new FormControl({ value: '', disabled: !this.canEdit }),
      privateWellHoushold: new FormControl({ value: '', disabled: !this.canEdit }),
      privateWellProperty: new FormControl({ value: '', disabled: !this.canEdit }),
      createNewWell: new FormControl({ value: false, disabled: !this.canEdit }),
      wellDamage: new FormControl({ value: '', disabled: !this.canEdit }),
      wellDamageComments: new FormControl({ value: '', disabled: !this.canEdit }),
      wellSystemPlasticRubber: new FormControl({ value: '', disabled: !this.canEdit }),

      // wildire
      newApplication: new FormControl({ value: true, disabled: false }),
      propertyImpacted: new FormControl({ value: '', disabled: !this.canEdit }),
      previousVoucher: new FormControl({ value: '', disabled: !this.canEdit }),
      wildfire: new FormControl({ value: '', disabled: !this.canEdit }),
      wildfireOther: new FormControl({ value: '', disabled: !this.canEdit }),
      wildfireList: new FormControl({ value: this.voucherService.wildfireList, disabled: !this.canEdit }),

      // household
      primaryResidence: new FormControl({ value: '', disabled: !this.canEdit }),
      residenceOther: new FormControl({ value: '', disabled: !this.canEdit }),
      tenant: new FormControl({ value: '', disabled: !this.canEdit }),
      householdShared: new FormControl({ value: '', disabled: !this.canEdit }),
      householdsServed: new FormControl({ value: '', disabled: !this.canEdit }),
      householdsServedOther: new FormControl({ value: '', disabled: !this.canEdit }),
      householdSize: new FormControl({ value: '', disabled: !this.canEdit }),
      householdSizeOther: new FormControl({ value: '', disabled: !this.canEdit }),
      household1PersonIncome: new FormControl({ value: '', disabled: !this.canEdit }),

      confidential: new FormControl({ value: '', disabled: !this.canEdit }),
      householdPrivateWell: new FormControl({ value: '', disabled: !this.canEdit }),
      propertyLocation: new FormControl({ value: '', disabled: !this.canEdit }),
      wellNitrateTest: new FormControl({ value: '', disabled: !this.canEdit }),
      wellNitrateTestOther: new FormControl({ value: '', disabled: !this.canEdit }),

      // real-d
      volunteerRaceEthInfo: new FormControl({ value: '', disabled: false }),
      centralAmerican: new FormControl({ value: false, disabled: false }),
      mexican: new FormControl({ value: false, disabled: false }),
      southAmerican: new FormControl({ value: false, disabled: false }),
      otherLatinx: new FormControl({ value: false, disabled: false }),
      chamoru: new FormControl({ value: false, disabled: false }),
      marshallese: new FormControl({ value: false, disabled: false }),
      micronesian: new FormControl({ value: false, disabled: false }),
      nativeHawaiian: new FormControl({ value: false, disabled: false }),
      voluntsamoaneerRaceEthInfo: new FormControl({ value: false, disabled: false }),
      samoan: new FormControl({ value: false, disabled: false }),
      otherPacificIslander: new FormControl({ value: false, disabled: false }),
      slavic: new FormControl({ value: false, disabled: false }),
      westernEuropean: new FormControl({ value: false, disabled: false }),
      easternEuropean: new FormControl({ value: false, disabled: false }),
      otherWhite: new FormControl({ value: false, disabled: false }),
      americanIndian: new FormControl({ value: false, disabled: false }),
      alaskaNative: new FormControl({ value: false, disabled: false }),
      canadianFirstNation: new FormControl({ value: false, disabled: false }),
      indigenousCentralAmerican: new FormControl({ value: false, disabled: false }),
      africanAmerican: new FormControl({ value: false, disabled: false }),
      afroCarribbean: new FormControl({ value: false, disabled: false }),
      filipino: new FormControl({ value: false, disabled: false }),
      somali: new FormControl({ value: false, disabled: false }),
      ethiopian: new FormControl({ value: false, disabled: false }),
      otherAfrican: new FormControl({ value: false, disabled: false }),
      otherBlack: new FormControl({ value: false, disabled: false }),
      middleEastern: new FormControl({ value: false, disabled: false }),
      northAfrican: new FormControl({ value: false, disabled: false }),
      asianIndian: new FormControl({ value: false, disabled: false }),
      cambodian: new FormControl({ value: false, disabled: false }),
      chinese: new FormControl({ value: false, disabled: false }),
      myanmar: new FormControl({ value: false, disabled: false }),
      hmong: new FormControl({ value: false, disabled: false }),
      japanese: new FormControl({ value: false, disabled: false }),
      korean: new FormControl({ value: false, disabled: false }),
      laotian: new FormControl({ value: false, disabled: false }),
      southAsian: new FormControl({ value: false, disabled: false }),
      vietnamese: new FormControl({ value: false, disabled: false }),
      otherAsian: new FormControl({ value: false, disabled: false }),
      dontKnow: new FormControl({ value: '', disabled: false }),
      raceEthDecline: new FormControl({ value: false, disabled: false }),
      raceEthOther: new FormControl({ value: '', disabled: false }),
      raceEthPrimary: new FormControl({ value: '', disabled: false }),
      languagAtHome: new FormControl({ value: '', disabled: false }),
      languageAtHomeOther: new FormControl({ value: '', disabled: false }),
      languageSpoken: new FormControl({ value: '', disabled: false }),
      languageWritten: new FormControl({ value: '', disabled: false }),
      needInterpreter: new FormControl({ value: '', disabled: false }),
      needInterpreterType: new FormControl({ value: '', disabled: false }),
      needInterpreterTypeOther: new FormControl({ value: '', disabled: false }),
      englishProficiency: new FormControl({ value: '', disabled: false }),
      hearing: new FormControl({ value: '', disabled: false }),
      hearingComments: new FormControl({ value: '', disabled: false }),
      vision: new FormControl({ value: '', disabled: false }),
      visionComments: new FormControl({ value: '', disabled: false }),
      mobility: new FormControl({ value: '', disabled: false }),
      mobilityComments: new FormControl({ value: '', disabled: false }),
      focus: new FormControl({ value: '', disabled: false }),
      focusComment: new FormControl({ value: '', disabled: false }),
      dressingBathing: new FormControl({ value: '', disabled: false }),
      dressingBathingComments: new FormControl({ value: '', disabled: false }),
      learning: new FormControl({ value: '', disabled: false }),
      learningComments: new FormControl({ value: '', disabled: false }),
      learnAboutVoucher: new FormControl({ value: '', disabled: !this.canEdit }),
      learnAboutVoucherOther: new FormControl({ value: '', disabled: !this.canEdit }),
      whoIsCompletingForm: new FormControl({ value: '', disabled: false }),
      communityBasedOrganizationEmail: new FormControl({ value: '', disabled: false }),
      communication: new FormControl({ value: '', disabled: false }),
      communicationComments: new FormControl({ value: '', disabled: false }),
      selfSupport: new FormControl({ value: '', disabled: false }),
      selfSupportComments: new FormControl({ value: '', disabled: false }),
      moods: new FormControl({ value: '', disabled: false }),
      moodsComments: new FormControl({ value: '', disabled: false }),
      selfGenerateVoucherIdentifier: new FormControl({ value: this.application.selfGenerateVoucherIdentifier, disabled: !this.canEdit }),
      selfGeneratedVoucherIdentifer: new FormControl({ value: this.application.selfGeneratedVoucherIdentifer, disabled: !this.canEdit }),

      age15AndBelow: new FormControl({ value: 0, disabled: !this.canEdit }, Validators.pattern("^[0-9]*$")),
      age16AndAbove: new FormControl({ value: 0, disabled: !this.canEdit }, Validators.pattern("^[0-9]*$")),
      pregnancyInHousehold: new FormControl({ value: false, disabled: !this.canEdit }),
      infantsInHousehold: new FormControl({ value: false, disabled: !this.canEdit }),
      canvasCode: new FormControl({ value: '', disabled: false }),
      applicantAddressUnit: new FormControl({ value: '', disabled: !this.canEdit }),
      createNewHousingUnit: new FormControl({ value: false, disabled: false }),
      selectedHousingUnitId: new FormControl({ value: 0, disabled: false }),
      createNewHousehold: new FormControl({ value: false, disabled: false }),
      selectedHouseholdId: new FormControl({ value: 0, disabled: false }),
      scheduleTest: new FormControl({ value: false, disabled: !this.canEdit }),
      preferredSampleDays: new FormControl({ value: this.application.preferredSampleDays, disabled: !this.canEdit }),
      preferredSampleTimes: new FormControl({ value: this.application.preferredSampleTimes, disabled: !this.canEdit }),
      applicationSource: new FormControl({ value: this.application.applicationSource, disabled: false }),
      residenceType: new FormControl({ value: this.application.residenceType, disabled: !this.canEdit }),
      residenceTypeOther: new FormControl({ value: this.application.residenceTypeOther, disabled: !this.canEdit }),
    });

    this.showSelfGeneratedVoucherIdentifer = this.application.selfGenerateVoucherIdentifier;

    if (this.application.id > 0) {

      this.voucherApplicationForm.get('applicationStatus').setValue(this.application.applicationStatus);
      this.voucherApplicationForm.get('applicationType').setValue(this.application.applicationType);
      this.voucherApplicationForm.get('wellLookup').setValue('');
      this.voucherApplicationForm.get('preferredContactType').setValue(this.application.preferredContactType);
      this.voucherApplicationForm.get('preferredContactComments').setValue(this.application.preferredContactComments);
      this.voucherApplicationForm.get('applicantContactName').setValue(this.application.applicantContactName);
      this.voucherApplicationForm.get('applicantContactEmail').setValue(this.application.applicantContactEmail);
      this.voucherApplicationForm.get('applicantContactPhone').setValue(this.application.applicantContactPhone);
      this.voucherApplicationForm.get('applicantAddress').setValue(this.application.applicantAddress);
      this.voucherApplicationForm.get('applicantCity').setValue(this.application.applicantCity);
      this.voucherApplicationForm.get('applicantState').setValue(this.application.applicantState);
      this.voucherApplicationForm.get('applicantZip').setValue(this.application.applicantZip);
      this.voucherApplicationForm.get('applicantCounty').setValue(this.application.applicantCounty);

      this.voucherApplicationForm.get('mailingAddress').setValue(this.application.mailingAddress);
      this.voucherApplicationForm.get('mailingCity').setValue(this.application.mailingCity);
      this.voucherApplicationForm.get('mailingState').setValue(this.application.mailingState);
      this.voucherApplicationForm.get('mailingZip').setValue(this.application.mailingZip);
      this.voucherApplicationForm.get('mailingCounty').setValue(this.application.mailingCounty);

      // well
      this.voucherApplicationForm.get('selectedWellId').setValue(this.application.selectedWellId);
      this.voucherApplicationForm.get('wellAddress').setValue(this.application.wellAddress);
      this.voucherApplicationForm.get('wellCity').setValue(this.application.wellCity);
      this.voucherApplicationForm.get('wellState').setValue(this.application.wellState);
      this.voucherApplicationForm.get('wellZip').setValue(this.application.wellZip);
      this.voucherApplicationForm.get('wellCounty').setValue(this.application.wellCounty);
      this.voucherApplicationForm.get('wellLabelTagNumber').setValue(this.application.wellLabelTagNumber);
      this.voucherApplicationForm.get('wellLogNumber').setValue(this.application.wellLogNumber);
      this.voucherApplicationForm.get('privateWellHoushold').setValue(this.application.privateWellHoushold);
      this.voucherApplicationForm.get('privateWellProperty').setValue(this.application.privateWellProperty);
      this.voucherApplicationForm.get('createNewWell').setValue(this.application.createNewWell);
      this.voucherApplicationForm.get('wellDamage').setValue(this.application.wellDamage);
      this.voucherApplicationForm.get('wellDamageComments').setValue(this.application.wellDamageComments);
      this.voucherApplicationForm.get('wellSystemPlasticRubber').setValue(this.application.wellSystemPlasticRubber);

      // wildfire
      this.voucherApplicationForm.get('newApplication').setValue(this.application.newApplication);
      this.voucherApplicationForm.get('propertyImpacted').setValue(this.application.propertyImpacted);
      this.voucherApplicationForm.get('previousVoucher').setValue(this.application.previousVoucher);
      this.voucherApplicationForm.get('wildfire').setValue(this.application.wildfire);
      this.voucherApplicationForm.get('wildfireOther').setValue(this.application.wildfireOther);
      this.voucherApplicationForm.get('wildfireList').setValue(this.voucherService.wildfireList);

      // household
      this.voucherApplicationForm.get('primaryResidence').setValue(this.application.primaryResidence);
      this.voucherApplicationForm.get('residenceOther').setValue(this.application.residenceOther);
      this.voucherApplicationForm.get('tenant').setValue(this.application.tenant);
      this.voucherApplicationForm.get('householdShared').setValue(this.application.householdShared);
      this.voucherApplicationForm.get('householdsServed').setValue(this.application.householdsServed);
      this.voucherApplicationForm.get('householdsServedOther').setValue(this.application.householdsServedOther);
      this.voucherApplicationForm.get('householdSize').setValue(this.application.householdSize);
      this.voucherApplicationForm.get('householdSizeOther').setValue(this.application.householdSizeOther);
      this.voucherApplicationForm.get('household1PersonIncome').setValue(this.application.household1PersonIncome);

      this.voucherApplicationForm.get('confidential').setValue(this.application.confidential);
      this.voucherApplicationForm.get('householdPrivateWell').setValue(this.application.householdPrivateWell);
      this.voucherApplicationForm.get('propertyLocation').setValue(this.application.propertyLocation);
      this.voucherApplicationForm.get('wellNitrateTest').setValue(this.application.wellNitrateTest);
      this.voucherApplicationForm.get('wellNitrateTestOther').setValue(this.application.wellNitrateTestOther);

      // real-d
      this.voucherApplicationForm.get('volunteerRaceEthInfo').setValue(this.application.volunteerRaceEthInfo);

      this.voucherApplicationForm.get('centralAmerican').setValue(this.application.centralAmerican);
      if (this.application.centralAmerican) { this.setPrimaryRaceEthnicity('centralAmerican'); }

      this.voucherApplicationForm.get('mexican').setValue(this.application.mexican);
      if (this.application.mexican) { this.setPrimaryRaceEthnicity('mexican'); }

      this.voucherApplicationForm.get('southAmerican').setValue(this.application.southAmerican);
      if (this.application.southAmerican) { this.setPrimaryRaceEthnicity('southAmerican'); }

      this.voucherApplicationForm.get('otherLatinx').setValue(this.application.otherLatinx);
      if (this.application.otherLatinx) { this.setPrimaryRaceEthnicity('otherLatinx'); }

      this.voucherApplicationForm.get('chamoru').setValue(this.application.chamoru);
      if (this.application.chamoru) { this.setPrimaryRaceEthnicity('chamoru'); }

      this.voucherApplicationForm.get('marshallese').setValue(this.application.marshallese);
      if (this.application.marshallese) { this.setPrimaryRaceEthnicity('marshallese'); }

      this.voucherApplicationForm.get('micronesian').setValue(this.application.micronesian);
      if (this.application.micronesian) { this.setPrimaryRaceEthnicity('micronesian'); }

      this.voucherApplicationForm.get('nativeHawaiian').setValue(this.application.nativeHawaiian);
      if (this.application.nativeHawaiian) { this.setPrimaryRaceEthnicity('nativeHawaiian'); }

      this.voucherApplicationForm.get('samoan').setValue(this.application.samoan);
      if (this.application.samoan) { this.setPrimaryRaceEthnicity('samoan'); }

      this.voucherApplicationForm.get('otherPacificIslander').setValue(this.application.otherPacificIslander);
      if (this.application.otherPacificIslander) { this.setPrimaryRaceEthnicity('otherPacificIslander'); }

      this.voucherApplicationForm.get('slavic').setValue(this.application.slavic);
      if (this.application.slavic) { this.setPrimaryRaceEthnicity('slavic'); }

      this.voucherApplicationForm.get('westernEuropean').setValue(this.application.westernEuropean);
      if (this.application.westernEuropean) { this.setPrimaryRaceEthnicity('westernEuropean'); }

      this.voucherApplicationForm.get('easternEuropean').setValue(this.application.easternEuropean);
      if (this.application.easternEuropean) { this.setPrimaryRaceEthnicity('easternEuropean'); }

      this.voucherApplicationForm.get('otherWhite').setValue(this.application.otherWhite);
      if (this.application.otherWhite) { this.setPrimaryRaceEthnicity('otherWhite'); }

      this.voucherApplicationForm.get('americanIndian').setValue(this.application.americanIndian);
      if (this.application.americanIndian) { this.setPrimaryRaceEthnicity('americanIndian'); }

      this.voucherApplicationForm.get('alaskaNative').setValue(this.application.alaskaNative);
      if (this.application.alaskaNative) { this.setPrimaryRaceEthnicity('alaskaNative'); }

      this.voucherApplicationForm.get('canadianFirstNation').setValue(this.application.canadianFirstNation);
      if (this.application.canadianFirstNation) { this.setPrimaryRaceEthnicity('canadianFirstNation'); }

      this.voucherApplicationForm.get('indigenousCentralAmerican').setValue(this.application.indigenousCentralAmerican);
      if (this.application.indigenousCentralAmerican) { this.setPrimaryRaceEthnicity('indigenousCentralAmerican'); }

      this.voucherApplicationForm.get('africanAmerican').setValue(this.application.africanAmerican);
      if (this.application.africanAmerican) { this.setPrimaryRaceEthnicity('africanAmerican'); }

      this.voucherApplicationForm.get('afroCarribbean').setValue(this.application.afroCarribbean);
      if (this.application.afroCarribbean) { this.setPrimaryRaceEthnicity('afroCarribbean'); }

      this.voucherApplicationForm.get('somali').setValue(this.application.somali);
      if (this.application.somali) { this.setPrimaryRaceEthnicity('somali'); }

      this.voucherApplicationForm.get('ethiopian').setValue(this.application.ethiopian);
      if (this.application.ethiopian) { this.setPrimaryRaceEthnicity('ethiopian'); }

      this.voucherApplicationForm.get('otherAfrican').setValue(this.application.otherAfrican);
      if (this.application.otherAfrican) { this.setPrimaryRaceEthnicity('otherAfrican'); }

      this.voucherApplicationForm.get('otherBlack').setValue(this.application.otherBlack);
      if (this.application.otherBlack) { this.setPrimaryRaceEthnicity('otherBlack'); }

      this.voucherApplicationForm.get('middleEastern').setValue(this.application.middleEastern);
      if (this.application.middleEastern) { this.setPrimaryRaceEthnicity('middleEastern'); }

      this.voucherApplicationForm.get('northAfrican').setValue(this.application.northAfrican);
      if (this.application.northAfrican) { this.setPrimaryRaceEthnicity('northAfrican'); }

      this.voucherApplicationForm.get('asianIndian').setValue(this.application.asianIndian);
      if (this.application.asianIndian) { this.setPrimaryRaceEthnicity('asianIndian'); }

      this.voucherApplicationForm.get('cambodian').setValue(this.application.cambodian);
      if (this.application.cambodian) { this.setPrimaryRaceEthnicity('cambodian'); }

      this.voucherApplicationForm.get('chinese').setValue(this.application.chinese);
      if (this.application.chinese) { this.setPrimaryRaceEthnicity('chinese'); }

      this.voucherApplicationForm.get('myanmar').setValue(this.application.myanmar);
      if (this.application.myanmar) { this.setPrimaryRaceEthnicity('myanmar'); }

      this.voucherApplicationForm.get('hmong').setValue(this.application.hmong);
      if (this.application.hmong) { this.setPrimaryRaceEthnicity('hmong'); }

      this.voucherApplicationForm.get('japanese').setValue(this.application.japanese);
      if (this.application.japanese) { this.setPrimaryRaceEthnicity('japanese'); }

      this.voucherApplicationForm.get('filipino').setValue(this.application.filipino);
      if (this.application.filipino) { this.setPrimaryRaceEthnicity('filipino'); }

      this.voucherApplicationForm.get('korean').setValue(this.application.korean);
      if (this.application.korean) { this.setPrimaryRaceEthnicity('korean'); }

      this.voucherApplicationForm.get('laotian').setValue(this.application.laotian);
      if (this.application.laotian) { this.setPrimaryRaceEthnicity('laotian'); }

      this.voucherApplicationForm.get('southAsian').setValue(this.application.southAsian);
      if (this.application.southAsian) { this.setPrimaryRaceEthnicity('southAsian'); }

      this.voucherApplicationForm.get('vietnamese').setValue(this.application.vietnamese);
      if (this.application.vietnamese) { this.setPrimaryRaceEthnicity('vietnamese'); }

      this.voucherApplicationForm.get('otherAsian').setValue(this.application.otherAsian);
      if (this.application.otherAsian) { this.setPrimaryRaceEthnicity('otherAsian'); }

      this.voucherApplicationForm.get('dontKnow').setValue(this.application.dontKnow);
      if (this.application.dontKnow) { this.setPrimaryRaceEthnicity('dontKnow'); }

      this.voucherApplicationForm.get('raceEthDecline').setValue(this.application.raceEthDecline);
      if (this.application.raceEthDecline) { this.setPrimaryRaceEthnicity('raceEthDecline'); }

      this.voucherApplicationForm.get('raceEthOther').setValue(this.application.raceEthOther);
      this.voucherApplicationForm.get('raceEthPrimary').setValue(this.application.raceEthPrimary);
      this.voucherApplicationForm.get('languagAtHome').setValue(this.application.languagAtHome);
      this.voucherApplicationForm.get('languageAtHomeOther').setValue(this.application.languageAtHomeOther);
      this.voucherApplicationForm.get('languageSpoken').setValue(this.application.languageSpoken);
      this.voucherApplicationForm.get('languageWritten').setValue(this.application.languageWritten);
      this.voucherApplicationForm.get('needInterpreter').setValue(this.application.needInterpreter);
      this.voucherApplicationForm.get('needInterpreterType').setValue(this.application.needInterpreterType);
      this.voucherApplicationForm.get('needInterpreterTypeOther').setValue(this.application.needInterpreterTypeOther);
      this.voucherApplicationForm.get('englishProficiency').setValue(this.application.englishProficiency);
      this.voucherApplicationForm.get('hearing').setValue(this.application.hearing);
      this.voucherApplicationForm.get('hearingComments').setValue(this.application.hearingComments);
      this.voucherApplicationForm.get('vision').setValue(this.application.vision);
      this.voucherApplicationForm.get('visionComments').setValue(this.application.visionComments);
      this.voucherApplicationForm.get('mobility').setValue(this.application.mobility);
      this.voucherApplicationForm.get('mobilityComments').setValue(this.application.mobilityComments);
      this.voucherApplicationForm.get('focus').setValue(this.application.focus);
      this.voucherApplicationForm.get('focusComment').setValue(this.application.focusComment);
      this.voucherApplicationForm.get('dressingBathing').setValue(this.application.dressingBathing);
      this.voucherApplicationForm.get('dressingBathingComments').setValue(this.application.dressingBathingComments);
      this.voucherApplicationForm.get('learning').setValue(this.application.learning);
      this.voucherApplicationForm.get('learningComments').setValue(this.application.learningComments);
      this.voucherApplicationForm.get('learnAboutVoucher').setValue(this.application.learnAboutVoucher);
      this.voucherApplicationForm.get('learnAboutVoucherOther').setValue(this.application.learnAboutVoucherOther);
      this.voucherApplicationForm.get('whoIsCompletingForm').setValue(this.application.whoIsCompletingForm);
      this.voucherApplicationForm.get('communityBasedOrganizationEmail').setValue(this.application.communityBasedOrganizationEmail);
      this.voucherApplicationForm.get('communication').setValue(this.application.communication);
      this.voucherApplicationForm.get('communicationComments').setValue(this.application.communicationComments);
      this.voucherApplicationForm.get('selfSupport').setValue(this.application.selfSupport);
      this.voucherApplicationForm.get('selfSupportComments').setValue(this.application.selfSupportComments);
      this.voucherApplicationForm.get('moods').setValue(this.application.moods);
      this.voucherApplicationForm.get('moodsComments').setValue(this.application.moodsComments);

      this.voucherApplicationForm.get('age15AndBelow').setValue(this.application.age15AndBelow);
      this.voucherApplicationForm.get('age16AndAbove').setValue(this.application.age16AndAbove);
      this.voucherApplicationForm.get('pregnancyInHousehold').setValue(this.application.pregnancyInHousehold ? "true" : "false");
      this.voucherApplicationForm.get('infantsInHousehold').setValue(this.application.infantsInHousehold ? "true" : "false");
      this.voucherApplicationForm.get('canvasCode').setValue(this.application.canvasCode);
      this.voucherApplicationForm.get('applicantAddressUnit').setValue(this.application.applicantAddressUnit);
      this.voucherApplicationForm.get('createNewHousingUnit').setValue(this.application.createNewHousingUnit);
      this.voucherApplicationForm.get('selectedHousingUnitId').setValue(this.application.selectedHousingUnitId);
      this.voucherApplicationForm.get('createNewHousehold').setValue(this.application.createNewHousehold);
      this.voucherApplicationForm.get('selectedHouseholdId').setValue(this.application.selectedHouseholdId);
      this.voucherApplicationForm.get('scheduleTest').setValue(this.application.scheduleTest);
      if (this.application.preferredSampleDays != null && this.application.preferredSampleDays.length > 0) {
        this.voucherApplicationForm.get('preferredSampleDays').setValue(this.application.preferredSampleDays.split(','));
      }
      if (this.application.preferredSampleTimes != null && this.application.preferredSampleTimes.length > 0) {
        this.voucherApplicationForm.get('preferredSampleTimes').setValue(this.application.preferredSampleTimes.split(','));
        this.voucherApplicationForm.get('applicationSource').setValue(this.application.applicationSource);
      }
      this.voucherApplicationForm.get('residenceType').setValue(this.application.residenceType);
      this.voucherApplicationForm.get('residenceTypeOther').setValue(this.application.residenceTypeOther);
    }

    this.showHouseholdSize();
    this.voucherStatusChange();
  }

  getFormValues() {
    this.application.applicationStatus = this.voucherApplicationForm.getRawValue().applicationStatus;
    this.application.applicationType = this.voucherApplicationForm.getRawValue().applicationType;
    this.application.preferredContactType = this.voucherApplicationForm.getRawValue().preferredContactType;
    this.application.preferredContactComments = this.voucherApplicationForm.getRawValue().preferredContactComments;
    this.application.applicantContactName = this.voucherApplicationForm.getRawValue().applicantContactName;
    this.application.applicantContactPhone = this.voucherApplicationForm.getRawValue().applicantContactPhone;
    this.application.applicantContactEmail = this.voucherApplicationForm.getRawValue().applicantContactEmail;
    this.application.applicantAddress = this.voucherApplicationForm.getRawValue().applicantAddress;
    this.application.applicantCity = this.voucherApplicationForm.getRawValue().applicantCity;
    this.application.applicantState = this.voucherApplicationForm.getRawValue().applicantState;
    this.application.applicantZip = this.voucherApplicationForm.getRawValue().applicantZip;
    this.application.applicantCounty = this.voucherApplicationForm.getRawValue().applicantCounty;

    this.application.mailingAddress = this.voucherApplicationForm.getRawValue().mailingAddress;
    this.application.mailingCity = this.voucherApplicationForm.getRawValue().mailingCity;
    this.application.mailingState = this.voucherApplicationForm.getRawValue().mailingState;
    this.application.mailingZip = this.voucherApplicationForm.getRawValue().mailingZip;
    this.application.mailingCounty = this.voucherApplicationForm.getRawValue().mailingCounty;

    if (this.voucherApplicationForm.getRawValue().selectedWellId == null
      || this.voucherApplicationForm.getRawValue().selectedWellId == '') {
      this.application.selectedWellId = 0;
    }
    else {
      this.application.selectedWellId = this.voucherApplicationForm.getRawValue().selectedWellId;
    }

    this.application.wellAddress = this.voucherApplicationForm.getRawValue().wellAddress;
    this.application.wellCity = this.voucherApplicationForm.getRawValue().wellCity;
    this.application.wellState = this.voucherApplicationForm.getRawValue().wellState;
    this.application.wellZip = this.voucherApplicationForm.getRawValue().wellZip;
    this.application.wellCounty = this.voucherApplicationForm.getRawValue().wellCounty;
    this.application.wellLabelTagNumber = this.voucherApplicationForm.getRawValue().wellLabelTagNumber;
    this.application.wellLogNumber = this.voucherApplicationForm.getRawValue().wellLogNumber;
    this.application.privateWellHoushold = this.voucherApplicationForm.getRawValue().privateWellHoushold;
    this.application.privateWellProperty = this.voucherApplicationForm.getRawValue().privateWellProperty;
    this.application.createNewWell = this.voucherApplicationForm.getRawValue().createNewWell;
    this.application.wellDamage = this.voucherApplicationForm.getRawValue().wellDamage;
    this.application.wellDamageComments = this.voucherApplicationForm.getRawValue().wellDamageComments;
    this.application.wellSystemPlasticRubber = this.voucherApplicationForm.getRawValue().wellSystemPlasticRubber;

    this.application.newApplication = this.voucherApplicationForm.getRawValue().newApplication;
    this.application.propertyImpacted = this.voucherApplicationForm.getRawValue().propertyImpacted;
    this.application.previousVoucher = this.voucherApplicationForm.getRawValue().previousVoucher;
    if (this.voucherApplicationForm.getRawValue().wildfire == undefined ||
      this.voucherApplicationForm.getRawValue().wildfire == null ||
      this.voucherApplicationForm.getRawValue().wildfire.toString().length == 0) {
      this.application.wildfire = [];
    }
    else {
      this.application.wildfire = this.voucherApplicationForm.getRawValue().wildfire;
    }
    this.application.wildfireOther = this.voucherApplicationForm.getRawValue().wildfireOther;

    // household
    this.application.primaryResidence = this.voucherApplicationForm.getRawValue().primaryResidence;
    this.application.residenceOther = this.voucherApplicationForm.getRawValue().residenceOther;
    this.application.tenant = this.voucherApplicationForm.getRawValue().tenant;
    this.application.householdShared = this.voucherApplicationForm.getRawValue().householdShared;
    this.application.householdsServed = this.voucherApplicationForm.getRawValue().householdsServed;
    this.application.householdsServedOther = this.voucherApplicationForm.getRawValue().householdsServedOther;
    this.application.householdSize = this.voucherApplicationForm.getRawValue().householdSize;
    this.application.householdSizeOther = this.voucherApplicationForm.getRawValue().householdSizeOther;
    this.application.household1PersonIncome = this.voucherApplicationForm.getRawValue().household1PersonIncome;

    this.application.confidential = this.voucherApplicationForm.getRawValue().confidential;
    this.application.householdPrivateWell = this.voucherApplicationForm.getRawValue().householdPrivateWell;
    this.application.propertyLocation = this.voucherApplicationForm.getRawValue().propertyLocation;
    this.application.wellNitrateTest = this.voucherApplicationForm.getRawValue().wellNitrateTest;
    this.application.wellNitrateTestOther = this.voucherApplicationForm.getRawValue().wellNitrateTestOther;

    // real-d
    this.application.volunteerRaceEthInfo = this.voucherApplicationForm.getRawValue().volunteerRaceEthInfo;
    this.application.centralAmerican = this.voucherApplicationForm.getRawValue().centralAmerican;
    this.application.mexican = this.voucherApplicationForm.getRawValue().mexican;
    this.application.southAmerican = this.voucherApplicationForm.getRawValue().southAmerican;
    this.application.otherLatinx = this.voucherApplicationForm.getRawValue().otherLatinx;
    this.application.chamoru = this.voucherApplicationForm.getRawValue().chamoru;
    this.application.marshallese = this.voucherApplicationForm.getRawValue().marshallese;
    this.application.micronesian = this.voucherApplicationForm.getRawValue().micronesian;
    this.application.nativeHawaiian = this.voucherApplicationForm.getRawValue().nativeHawaiian;
    this.application.samoan = this.voucherApplicationForm.getRawValue().samoan;
    this.application.otherPacificIslander = this.voucherApplicationForm.getRawValue().otherPacificIslander;
    this.application.slavic = this.voucherApplicationForm.getRawValue().slavic;
    this.application.westernEuropean = this.voucherApplicationForm.getRawValue().westernEuropean;
    this.application.easternEuropean = this.voucherApplicationForm.getRawValue().easternEuropean;
    this.application.otherWhite = this.voucherApplicationForm.getRawValue().otherWhite;
    this.application.americanIndian = this.voucherApplicationForm.getRawValue().americanIndian;
    this.application.alaskaNative = this.voucherApplicationForm.getRawValue().alaskaNative;
    this.application.canadianFirstNation = this.voucherApplicationForm.getRawValue().canadianFirstNation;
    this.application.indigenousCentralAmerican = this.voucherApplicationForm.getRawValue().indigenousCentralAmerican;
    this.application.africanAmerican = this.voucherApplicationForm.getRawValue().africanAmerican;
    this.application.afroCarribbean = this.voucherApplicationForm.getRawValue().afroCarribbean;
    this.application.filipino = this.voucherApplicationForm.getRawValue().filipino;
    this.application.somali = this.voucherApplicationForm.getRawValue().somali;
    this.application.ethiopian = this.voucherApplicationForm.getRawValue().ethiopian;
    this.application.otherAfrican = this.voucherApplicationForm.getRawValue().otherAfrican;
    this.application.otherBlack = this.voucherApplicationForm.getRawValue().otherBlack;
    this.application.middleEastern = this.voucherApplicationForm.getRawValue().middleEastern;
    this.application.northAfrican = this.voucherApplicationForm.getRawValue().northAfrican;
    this.application.asianIndian = this.voucherApplicationForm.getRawValue().asianIndian;
    this.application.cambodian = this.voucherApplicationForm.getRawValue().cambodian;
    this.application.chinese = this.voucherApplicationForm.getRawValue().chinese;
    this.application.myanmar = this.voucherApplicationForm.getRawValue().myanmar;
    this.application.hmong = this.voucherApplicationForm.getRawValue().hmong;
    this.application.japanese = this.voucherApplicationForm.getRawValue().japanese;
    this.application.korean = this.voucherApplicationForm.getRawValue().korean;
    this.application.laotian = this.voucherApplicationForm.getRawValue().laotian;
    this.application.southAsian = this.voucherApplicationForm.getRawValue().southAsian;
    this.application.vietnamese = this.voucherApplicationForm.getRawValue().vietnamese;
    this.application.otherAsian = this.voucherApplicationForm.getRawValue().otherAsian;
    this.application.dontKnow = this.voucherApplicationForm.getRawValue().dontKnow;
    this.application.raceEthDecline = this.voucherApplicationForm.getRawValue().raceEthDecline;
    this.application.raceEthOther = this.voucherApplicationForm.getRawValue().raceEthOther;
    this.application.raceEthPrimary = this.voucherApplicationForm.getRawValue().raceEthPrimary;
    this.application.languagAtHome = this.voucherApplicationForm.getRawValue().languagAtHome;
    this.application.languageAtHomeOther = this.voucherApplicationForm.getRawValue().languageAtHomeOther;
    this.application.languageSpoken = this.voucherApplicationForm.getRawValue().languageSpoken;
    this.application.languageWritten = this.voucherApplicationForm.getRawValue().languageWritten;
    this.application.needInterpreter = this.voucherApplicationForm.getRawValue().needInterpreter;
    this.application.needInterpreterType = this.voucherApplicationForm.getRawValue().needInterpreterType;
    this.application.needInterpreterTypeOther = this.voucherApplicationForm.getRawValue().needInterpreterTypeOther;
    this.application.englishProficiency = this.voucherApplicationForm.getRawValue().englishProficiency;
    this.application.hearing = this.voucherApplicationForm.getRawValue().hearing;
    this.application.hearingComments = this.voucherApplicationForm.getRawValue().hearingComments;
    this.application.vision = this.voucherApplicationForm.getRawValue().vision;
    this.application.visionComments = this.voucherApplicationForm.getRawValue().visionComments;
    this.application.mobility = this.voucherApplicationForm.getRawValue().mobility;
    this.application.mobilityComments = this.voucherApplicationForm.getRawValue().mobilityComments;
    this.application.focus = this.voucherApplicationForm.getRawValue().focus;
    this.application.focusComment = this.voucherApplicationForm.getRawValue().focusComment;
    this.application.dressingBathing = this.voucherApplicationForm.getRawValue().dressingBathing;
    this.application.dressingBathingComments = this.voucherApplicationForm.getRawValue().dressingBathingComments;
    this.application.learning = this.voucherApplicationForm.getRawValue().learning;
    this.application.learningComments = this.voucherApplicationForm.getRawValue().learningComments;
    this.application.learnAboutVoucher = this.voucherApplicationForm.getRawValue().learnAboutVoucher;
    this.application.learnAboutVoucherOther = this.voucherApplicationForm.getRawValue().learnAboutVoucherOther;
    this.application.whoIsCompletingForm = this.voucherApplicationForm.getRawValue().whoIsCompletingForm;
    this.application.communityBasedOrganizationEmail = this.voucherApplicationForm.getRawValue().communityBasedOrganizationEmail;
    this.application.communication = this.voucherApplicationForm.getRawValue().communication;
    this.application.communicationComments = this.voucherApplicationForm.getRawValue().communicationComments;
    this.application.selfSupport = this.voucherApplicationForm.getRawValue().selfSupport;
    this.application.selfSupportComments = this.voucherApplicationForm.getRawValue().selfSupportComments;
    this.application.moods = this.voucherApplicationForm.getRawValue().moods;
    this.application.moodsComments = this.voucherApplicationForm.getRawValue().moodsComments;
    this.application.selfGenerateVoucherIdentifier = this.voucherApplicationForm.getRawValue().selfGenerateVoucherIdentifier;
    this.application.selfGeneratedVoucherIdentifer = this.voucherApplicationForm.getRawValue().selfGeneratedVoucherIdentifer;
    if (this.application.selfGeneratedVoucherIdentifer == null) {
      this.application.selfGeneratedVoucherIdentifer = ''
    }

    this.application.age15AndBelow = +this.voucherApplicationForm.get('age15AndBelow').value;
    if (this.application.age15AndBelow == null || isNaN(this.application.age15AndBelow)) {
      this.application.age15AndBelow = 0;
    }
    this.application.age16AndAbove = +this.voucherApplicationForm.get('age16AndAbove').value;
    if (this.application.age16AndAbove == null || isNaN(this.application.age16AndAbove)) {
      this.application.age16AndAbove = 0;
    }
    this.application.pregnancyInHousehold = this.voucherApplicationForm.getRawValue().pregnancyInHousehold != null && this.voucherApplicationForm.getRawValue().pregnancyInHousehold == "true";
    this.application.infantsInHousehold = this.voucherApplicationForm.getRawValue().infantsInHousehold != null && this.voucherApplicationForm.getRawValue().infantsInHousehold == "true";
    this.application.canvasCode = this.voucherApplicationForm.getRawValue().canvasCode;
    this.application.applicantAddressUnit = this.voucherApplicationForm.getRawValue().applicantAddressUnit;
    this.application.createNewHousingUnit = this.voucherApplicationForm.getRawValue().createNewHousingUnit;
    this.application.applicationSource = this.voucherApplicationForm.getRawValue().applicationSource;
    if (this.voucherApplicationForm.getRawValue().selectedHousingUnitId == null
      || this.voucherApplicationForm.getRawValue().selectedHousingUnitId == '') {
      this.application.selectedHousingUnitId = 0;
    }
    else {
      this.application.selectedHousingUnitId = this.voucherApplicationForm.getRawValue().selectedHousingUnitId;
    }
    this.application.createNewHousehold = this.voucherApplicationForm.getRawValue().createNewHousehold;
    if (this.voucherApplicationForm.getRawValue().selectedHouseholdId == null
      || this.voucherApplicationForm.getRawValue().selectedHouseholdId == '') {
      this.application.selectedHouseholdId = 0;
    }
    else {
      this.application.selectedHouseholdId = this.voucherApplicationForm.getRawValue().selectedHouseholdId;
    }

    this.application.scheduleTest = this.voucherApplicationForm.getRawValue().scheduleTest;

    if (this.application.scheduleTest) {
      if (this.voucherApplicationForm.getRawValue().preferredSampleDays == null || this.voucherApplicationForm.getRawValue().preferredSampleDays.length == 0) {
        this.application.preferredSampleDays = '';
      }
      else {
        this.application.preferredSampleDays = this.voucherApplicationForm.getRawValue().preferredSampleDays.join();
      }
      if (this.voucherApplicationForm.getRawValue().preferredSampleTimes == null || this.voucherApplicationForm.getRawValue().preferredSampleTimes.length == 0) {
        this.application.preferredSampleTimes = '';
      }
      else {
        this.application.preferredSampleTimes = this.voucherApplicationForm.getRawValue().preferredSampleTimes.join();
      }

    }
    else {
      this.application.preferredSampleDays = '';
      this.application.preferredSampleTimes = ''
    }

    if (this.voucherApplicationForm.getRawValue().residenceType == null) {
      this.application.residenceType = '';
      this.application.residenceTypeOther = '';
    }
    else {
      this.application.residenceType = this.voucherApplicationForm.getRawValue().residenceType;
      if (this.application.residenceType == 'Other') {
        this.application.residenceTypeOther = this.voucherApplicationForm.getRawValue().residenceTypeOther;
      }
      else {
        this.application.residenceTypeOther = '';
      }
    }
  }

  confirmSelfGeneration() {
    if (!this.voucherApplicationForm.getRawValue().selfGenerateVoucherIdentifier) {
      this.sharedService.openConfirm("Are you sure you want to enter your own voucher identifier instead of letting the system generate one for you?");
      this.sharedService.confirmed().subscribe(confirmed => {
        if (!confirmed) {
          this.voucherApplicationForm.get('selfGenerateVoucherIdentifier').setValue(false);
          this.showSelfGeneratedVoucherIdentifer = false;
        }
        else {
          this.showSelfGeneratedVoucherIdentifer = true;
        }
      });
    }
  }

  onSubmit() {
    // #region validation

    if (this.canEdit && !this.voucherApplicationForm.valid) {
      this.toastr.error("Please fix validation errors");
      return;
    }

    this.lubgwmaValidationError = false;

    if (this.voucherApplicationForm.value.applicationType == this.voucherService.lubgwmaTestingVoucherType
      && this.voucherApplicationForm.value.householdShared == '') {
      this.lubgwmaValidationError = true;
      this.toastr.error("LUBGWMA Testing Voucher requires: Does your household share a well with another property");
      return;
    }

    if (this.voucherApplicationForm.value.applicationStatus == this.voucherService.issued) {
      if (!this.voucherApplicationForm.value.createNewWell
        && this.voucherApplicationForm.value.selectedWellId == '') {
        this.toastr.error("If the Voucher status is Issued, there must be an associated Well");
        return;
      }
    }

    this.getFormValues();

    //validate self generated voucher identifer is not blank
    if (this.canEdit &&
      this.application.selfGenerateVoucherIdentifier &&
      this.application.selfGeneratedVoucherIdentifer != null &&
      this.application.selfGeneratedVoucherIdentifer.length == 0 &&
      this.voucherApplicationForm.value.applicationStatus == this.voucherService.issued
    ) {
      this.toastr.error("Please enter a voucher identifer.  It cannot be left blank");
      return;
    }

    //validate self generated voucher identifer is alpha numeric only
    if (this.canEdit &&
      this.application.selfGenerateVoucherIdentifier &&
      this.application.selfGeneratedVoucherIdentifer.length > 0 &&
      this.voucherApplicationForm.value.applicationStatus == this.voucherService.issued &&
      !this.sharedService.isAlphanumeric(this.application.selfGeneratedVoucherIdentifer)) {
      this.toastr.error("Please enter a voucher identifer that is alpha numeric only.");
      return;
    }

    // #endregion

    this.processing = true;
    var returnId = 0;

    if (this.application.id > 0) {

      this.processing = false;
      //save application
      this.voucherService.saveVoucherApplication(this.application).subscribe(
        result => {
          this.toastr.success("Voucher Application Updated");
          this.processing = false;
          returnId = result;
        },
        error => {
          this.toastr.error(error.message);
          this.processing = false;
        },
        () => {
          if (this.application.applicationStatus == this.voucherService.issued && !this.isIssued) {
            this.router.navigate(['vouchers/edit/' + returnId]);
          }
          else if (this.isIssued) {
            this.loadApplication();
          }
          else {
            this.voucherService.getVoucherApplicationById(returnId).subscribe(result => {
              this.application = result;
              this.router.navigate(['vouchers/application/edit/' + this.application.id]);
            },
              error => {
                this.voucherService.onHttpError(error);
              }
            );
          }
        }
      );
    }
    else {

      //add application
      this.voucherService.saveVoucherApplication(this.application).subscribe(
        result => {
          this.toastr.success("Voucher Application Added");
          this.processing = false;
          returnId = result;
        },
        error => {
          this.toastr.error(error.message);
          this.processing = false;
        },
        () => {
          if (this.application.applicationStatus == this.voucherService.issued) {
            this.router.navigate(['vouchers/edit/' + returnId]);
          }
          else {
            this.voucherService.getVoucherApplicationById(returnId).subscribe(result => {
              this.application = result;
              this.router.navigate(['vouchers/application/edit/' + this.application.id]);
            },
              error => {
                this.voucherService.onHttpError(error);
              }
            );
          }
        }
      );
    }
  }

  editVoucher(voucherId: number) {
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: voucherId,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  voucherLookup() {
    this.voucherService.search.voucherId = '';
    this.voucherService.search.voucherApplicationId = ''
    this.voucherService.search.wellTag = '';
    this.voucherService.search.wellLog = ''
    this.voucherService.search.contact = '';
    this.voucherService.search.county = '';
    this.voucherService.search.address = '';
    this.voucherService.search.city = '';
    this.voucherService.search.zip = '';
    this.voucherService.search.county = '';
    this.voucherService.search.receivedStartDate = '';
    this.voucherService.search.receivedEndDate = '';
    this.voucherService.search.exceedencesDetected = false;
    this.voucherService.search.redeemed = false;
    this.voucherService.search.status = '';
    this.voucherService.search.type = '';
    this.voucherService.search.applicationIdentifier = '';
    if (this.application.wellAddress != null && this.application.wellAddress.length > 0) {
      this.voucherService.search.address = this.application.wellAddress;
    }
    // if(this.application.applicantContactPhone != null && this.application.applicantContactPhone.length > 0) {
    //   this.voucherService.search.phone = this.application.applicantContactPhone;
    // }
    if (this.application.applicantContactEmail != null && this.application.applicantContactEmail.length > 0) {
      this.voucherService.search.email = this.application.applicantContactEmail;
    }
    if (this.application.wellCity != null && this.application.wellCity.length > 0) {
      this.voucherService.search.city = this.application.wellCity;
    }

    this.voucherService.Search(this.voucherService.search).subscribe(
      result => {
        this.voucherService.searchResults = result;
        this.voucherService.haveSearchResults = true;
        this.voucherService.searchResultsCount = this.voucherService.searchResults.length;
        this.showVoucherResults = true;
        this.processing = false;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.flatVoucherResults = this.getFlatVoucherSearchResults();
        this.dataSourceVouchers = new MatTableDataSource<IHousehold>(this.flatVoucherResults);
        this.dataSourceVouchers.paginator = this.paginator;
        this.dataSourceVouchers.sort = this.sort;
      }
    );
  }

  getFlatVoucherSearchResults(): any[] {
    return this.voucherService.searchResults.map((result: any) => {
      return {
        voucherId: result.data?.voucherId || null,
        applicationIdentifier: result.data?.applicationIdentifier || null,
        applicantContactName: result.data?.applicantContactName || null,
        applicationType: result.data?.applicationType || null,
        applicationStatus: result.data?.applicationStatus || null,
        wellAddress1: result.data?.wellAddress1 || null,
        wellAddress2: result.data?.wellAddress2 || null,
        wellCity: result.data?.wellCity || null,
        wellState: result.data?.wellState || null,
        wellZip: result.data?.wellZip || null,
        wellCounty: result.data?.wellCounty || null,
        wellTag: result.data?.wellTag || null,
        wellLog: result.data?.wellLog || null,
      } as any;
    });
  }

  showHouseholdSize() {
    var value = this.voucherApplicationForm.value.householdSize;

    // value = UI dropdown
    if (value == "1 person") {
      this.formHouseholdSize = 1;
    }
    else if (value == "2 people") {
      this.formHouseholdSize = 2;
    }
    else if (value == "3 people") {
      this.formHouseholdSize = 3;
    }
    else if (value == "4 people") {
      this.formHouseholdSize = 4;
    }
    else if (value == "5 people") {
      this.formHouseholdSize = 5;
    }
    else if (value == "6 people or more") {
      this.formHouseholdSize = 6;
    }
    else {
      // prefer not to answer
      this.formHouseholdSize = 0;
    }
  }

  setPrimaryRaceEthnicity(id) {
    if (this.primaryRaceEthnicity.length > 0) {

      var find = this.primaryRaceEthnicity.find(f => f.id == id);

      if (find != undefined) {

        var index = this.primaryRaceEthnicity.findIndex(function (f) {
          // get the index
          return f.id === id;
        })

        if (index !== -1) {
          // remove from array
          this.primaryRaceEthnicity.splice(index, 1);
        }
      }
      else {
        this.primaryRaceEthnicity.push({
          id: id,
          value: this.voucherService.primaryRaceEthnicityList.find(f => f.id == id).value
        });
      }
    }
    else {
      this.primaryRaceEthnicity.push({
        id: id,
        value: this.voucherService.primaryRaceEthnicityList.find(f => f.id == id).value
      });
    }
  }

  wellLookup(wellId: string) {
    let validSearch = false;
    this.searchWell.searchBy = 'Well';
    if (wellId != null && wellId.length > 0) {

      this.searchWell.address = '';
      this.searchWell.city = '';
      this.searchWell.state = ''
      this.searchWell.zip = '';
      this.searchWell.county = '';
      this.searchWell.wellId = wellId;
    }
    else {
      this.searchWell.address = this.voucherApplicationForm.value.wellAddress;
      this.searchWell.city = this.voucherApplicationForm.value.wellCity;
      this.searchWell.state = this.voucherApplicationForm.value.wellState;
      this.searchWell.zip = this.voucherApplicationForm.value.wellZip;
      this.searchWell.county = this.voucherApplicationForm.value.wellCounty;
      this.searchWell.wellId = ''
    }

    if (
      (this.searchWell.address != null && this.searchWell.address.length > 0) ||
      (this.searchWell.city != null && this.searchWell.city.length > 0) ||
      (this.searchWell.zip != null && this.searchWell.zip.length > 0) ||
      (this.searchWell.wellId != null && this.searchWell.wellId.length > 0) ||
      (this.searchWell.county != null && this.searchWell.county.length > 0)
    ) {
      validSearch = true;
    }
    if (!validSearch) {
      this.toastr.error("Invalid Search Criteria.  Can't search for an empty well address.");
      return;
    }

    this.oregonWellDataService.SearchWell(this.searchWell).subscribe(
      result => {
        this.showWellResults = true;
        this.showWellResultsDiv = true;
        this.wells = result;
        if (this.wells.length == 0) {
          this.toastr.error("No Wells Found");
        }
        this.voucherApplicationForm.get('createNewWell').setValue(false);
        if (wellId != null && wellId.trim().length > 0) {
          this.voucherApplicationForm.get('selectedWellId').setValue(wellId.trim());
          this.voucherApplicationForm.get('selectedWellId').markAllAsTouched();
          //if there is no preselected housing unit then load it with the selected well housing units
          if (this.application.ohaHousingUnitId == null || this.application.ohaHousingUnitId.trim().length == 0) {
            this.selectedWellChange(+wellId.trim());
          }
        }
        else {
          this.voucherApplicationForm.get('selectedWellId').setValue(0);
        }
      },
      error => {
        this.oregonWellDataService.onHttpError(error);
      },
      () => {
        this.dataSource = new MatTableDataSource<IFuzzySearchResult>(this.wells);
      }
    );
  }

  selectedWellChange(wellId: number) {
    let wellResult = this.wells.find(w => w.data.wellId == wellId.toString());
    if (wellResult != null && wellResult.data.housingUnits != null && wellResult.data.housingUnits.length > 0) {
      this.dataSourceHousingUnit = new MatTableDataSource<IHousehold>(wellResult.data.housingUnits);
      this.housingUnits = wellResult.data.housingUnits;
    }
    else {
      this.dataSourceHousingUnit = new MatTableDataSource<IHousehold>([]);
    }
    this.voucherApplicationForm.get('selectedHousingUnitId').setValue(0);
  }

  housingUnitLookup(housingUnitId: string) {
    let validSearch = false;
    this.housingUnitSearch.searchBy = 'HousingUnits';

    if (housingUnitId != null && housingUnitId.length > 0) {
      this.housingUnitSearch.address1 = ''
      this.housingUnitSearch.city = '';
      this.housingUnitSearch.zip = '';
      this.housingUnitSearch.id = housingUnitId;

    }
    else {
      this.housingUnitSearch.address1 = this.application.applicantAddress;
      this.housingUnitSearch.city = this.application.applicantCity;
      this.housingUnitSearch.zip = this.application.applicantZip;
      this.housingUnitSearch.id = '';
    }

    if (
      (this.housingUnitSearch.address1 != null && this.housingUnitSearch.address1.length > 0) ||
      (this.housingUnitSearch.city != null && this.housingUnitSearch.city.length > 0) ||
      (this.housingUnitSearch.id != null && this.housingUnitSearch.id.length > 0) ||
      (this.housingUnitSearch.zip != null && this.housingUnitSearch.zip.length > 0)
    ) {
      validSearch = true;
    }
    if (!validSearch) {
      this.toastr.error("Invalid Search Criteria.  Can't search housing unit with empty contact info.");
      return;
    }

    this.householdService.Search(this.housingUnitSearch).subscribe(
      result => {
        this.housingUnits = result;
        if (this.housingUnits.length == 0) {
          this.toastr.error("No Housing Units Found");
        }
        if (housingUnitId != null && housingUnitId.trim().length > 0) {
          this.voucherApplicationForm.get('selectedHousingUnitId').setValue(housingUnitId.trim());
          this.voucherApplicationForm.get('selectedHousingUnitId').markAllAsTouched();
        }
        else {
          this.voucherApplicationForm.get('selectedHousingUnitId').setValue(0);
        }
      },
      error => {
        this.oregonWellDataService.onHttpError(error);
      },
      () => {
        this.flatHousingUnitResults = this.getFlatHousingUnitSearchResults();
        this.dataSourceHousingUnit = new MatTableDataSource<IHousehold>(this.flatHousingUnitResults);
      });
  }

  getFlatHousingUnitSearchResults(): any[] {
    return this.housingUnits.map((result: any) => {
      return {
        id: result.data?.id || null,
        contactName: result.data?.contactName || null,
        contactPhone: result.data?.contactPhone || null,
        contactEmail: result.data?.contactEmail || null,
        address1: result.data?.address1 || null,
        address2: result.data?.address2 || null,
        city: result.data?.city || null,
        state: result.data?.state || null,
        zip: result.data?.zip || null,
        county: result.data?.county || null,
        housingUnitId: result.data?.housingUnitId || null,
        householdId: result.data?.householdid || null,
        score: result.score || null,
      } as any;
    });
  }

  householdLookup(householdId: string) {
    let validSearch = false;
    this.householdSearch.searchBy = 'Household';

    if (householdId != null && householdId.length > 0) {
      this.householdSearch.address1 = '';
      this.householdSearch.city = '';
      this.householdSearch.zip = '';
      this.householdSearch.id = householdId;
    }
    else {
      this.householdSearch.address1 = this.application.applicantAddress;
      this.householdSearch.city = this.application.applicantCity;
      this.householdSearch.zip = this.application.applicantZip;
      this.householdSearch.id = '';
    }

    if (
      (this.householdSearch.address1 != null && this.householdSearch.address1.length > 0) ||
      (this.householdSearch.city != null && this.householdSearch.city.length > 0) ||
      (this.householdSearch.id != null && this.householdSearch.id.length > 0) ||
      (this.householdSearch.zip != null && this.householdSearch.zip.length > 0)
    ) {
      validSearch = true;
    }
    if (!validSearch) {
      this.toastr.error("Invalid Search Criteria.  Can't search housing unit with empty contact info.");
      return;
    }

    this.householdService.Search(this.householdSearch).subscribe(
      result => {
        this.households = result;
        if (this.households.length == 0) {
          this.toastr.error("No Households Found");
        }
        if (householdId != null && householdId.trim().length > 0) {
          this.voucherApplicationForm.get('selectedHouseholdId').setValue(householdId.trim());
          this.voucherApplicationForm.get('selectedHouseholdId').markAllAsTouched();
        }
        else {
          this.voucherApplicationForm.get('selectedHouseholdId').setValue(0);
        }
      },
      error => {
        this.oregonWellDataService.onHttpError(error);
      },
      () => {
        this.flatHouseholdResults = this.getFlatHouseholdSearchResults();
        this.dataSourceHousehold = new MatTableDataSource<IHousehold>(this.flatHouseholdResults);
      }
    );
  }

  createNewHouseholdSelected() {
    if (this.voucherApplicationForm.value.selectedHouseholdId > 0) {
      this.voucherApplicationForm.get('selectedHouseholdId').setValue(0);
    }
  }

  householdSelectedChange(id: number) {
    this.voucherApplicationForm.get('createNewHousehold').setValue(false);
  }

  housingUnitSelectedChange(id: number) {
    this.voucherApplicationForm.get('createNewHousingUnit').setValue(false);
    this.householdService.getHouseholdsByHousingUnitId(id).subscribe(
      result => {
        this.households = result;
        this.voucherApplicationForm.get('selectedHouseholdId').setValue(0);
      },
      error => {
        this.oregonWellDataService.onHttpError(error);
      },
      () => {
        this.dataSourceHousehold = new MatTableDataSource<IHousehold>(this.households);
      }
    );
  }

  getFlatHouseholdSearchResults(): any[] {
    return this.households.map((result: any) => {
      return {
        id: result.data?.id || null,
        contactName: result.data?.contactName || null,
        contactPhone: result.data?.contactPhone || null,
        contactEmail: result.data?.contactEmail || null,
        address1: result.data?.address1 || null,
        address2: result.data?.address2 || null,
        city: result.data?.city || null,
        state: result.data?.state || null,
        zip: result.data?.zip || null,
        county: result.data?.county || null,
        housingUnitId: result.data?.housingUnitId || null,
        householdId: result.data?.householdid || null,
        score: result.score || null,
      } as any;
    });
  }

  createNewHousingUnitSelected() {
    if (this.voucherApplicationForm.value.selectedHousingUnitId > 0) {
      this.voucherApplicationForm.get('selectedHousingUnitId').setValue(0);
    }
  }

  voucherStatusChange() {
    if (this.voucherApplicationForm.value.applicationStatus == 'Issued') {
      this.showWell = true;
      this.showHousehold = true;
      this.showHousingUnit = true;
      if (this.application.ohaWellId != null && this.application.ohaWellId.length > 0) {
        this.wellLookup(this.application.ohaWellId);
      }
      if (this.application.ohaHousingUnitId != null && this.application.ohaHousingUnitId.length > 0) {
        this.housingUnitLookup(this.application.ohaHousingUnitId);
      }
      if (this.application.ohaHouseholdId != null && this.application.ohaHouseholdId.length > 0) {
        this.householdLookup(this.application.ohaHouseholdId);
      }
    }
    else {
      this.showWell = false;
      this.showHousehold = false;
      this.showHousingUnit = false;
    }

    if (this.application.selectedWellId == 0) {
      this.wellAssociated = false;
    }
    else {
      this.wellAssociated = true;
    }
    if (this.application.selectedHousingUnitId == 0) {
      this.housingUnitAssociated = false;
    }
    else {
      this.housingUnitAssociated = true;
    }
    if (this.application.selectedHouseholdId == 0) {
      this.householdAssociated = false;
    }
    else {
      this.householdAssociated = true;
    }
  }

  showAssociatedWellResults() {
    if (this.showWellResultsDiv) {
      this.showWellResultsDiv = false;
    }
    else {
      this.showWellResultsDiv = true;
    }

    this.voucherApplicationForm.get('selectedWellId').setValue('');
  }
}